import { animate, inView, type AnimationSequence, cubicBezier, type Easing, stagger } from 'motion'

export const easings: { [key: string]: [number, number, number, number] } = {
    quint_in: [0.755, 0.06, 0.855, 0.06],
    quint_out: [0.23, 1, 0.32, 1],
    quint_inout: [0.86, 0, 0.07, 1],
    quad_in: [0.55, 0.085, 0.68, 0.53],
    quad_out: [0.25, 0.46, 0.45, 0.94],
    quad_inout: [0.455, 0.03, 0.515, 0.955],
    cubic_in: [0.55, 0.055, 0.675, 0.19],
    cubic_out: [0.215, 0.61, 0.355, 1],
    cubic_inout: [0.645, 0.045, 0.355, 1],
    quart_in: [0.895, 0.03, 0.685, 0.22],
    quart_out: [0.165, 0.84, 0.44, 1],
    quart_inout: [0.77, 0, 0.175, 1],
    expo_in: [0.95, 0.05, 0.795, 0.035],
    expo_out: [0.19, 1, 0.22, 1],
    expo_inout: [1, 0, 0, 1],
    sine_in: [0.47, 0, 0.745, 0.715],
    sine_out: [0.39, 0.575, 0.565, 1],
    sine_inout: [0.445, 0.05, 0.55, 0.95],
    circ_in: [0.6, 0.04, 0.98, 0.335],
    circ_out: [0.075, 0.82, 0.165, 1],
    circ_inout: [0.785, 0.135, 0.15, 0.86],
}
// let ease = cubicBezier(0.215, 0.61, 0.355, 1)
// let ease = cubicBezier(...easings.quad_out)
let ease = cubicBezier(0.22, 0.47, 0.34, 1)

export const animateEls = (element: HTMLElement) => {
    let animation = element.getAttribute('data-anim')
    let sequence: AnimationSequence = []

    if (animation === 'fade') {
        // sequence.push([element, { opacity: 1 }, { duration: 0.5, ease }])
    } else if (animation === 'fade-up') {
        element.style.opacity = '0'
        element.style.transform = 'translateY(50px)'
        sequence.push([
            element,
            { opacity: 1, transform: 'translateY(0px)' },
            { duration: 0.9, ease },
        ])
    } else if (animation === 'cols-fade') {
        let cols = element.querySelectorAll<HTMLElement>('.orbt-col')
        sequence.push([
            cols,
            { opacity: 1, transform: 'translateY(0px)' },
            { duration: 0.9, ease, delay: stagger(0.2) },
        ])
    } else if (animation === 'team') {
        let items = element.querySelectorAll<HTMLElement>('.team-member')
        items.forEach((item) => {
            item.style.opacity = '0'
            item.style.transform = 'translateY(50px)'
        })
        sequence.push([
            items,
            { opacity: 1, transform: 'translateY(0px)' },
            { duration: 0.9, ease, delay: stagger(0.1) },
        ])
    } else if (animation === 'cards') {
        let cards = element.querySelectorAll<HTMLElement>('.arcard')
        sequence.push([
            cards,
            {
                opacity: 1,
                transform: 'translateY(0px)',
            },
            { delay: stagger(0.2), duration: 0.9, ease },
        ])
    } else if (animation === 'postlist') {
        let items = element.querySelectorAll<HTMLElement>('.postlist-item')
        sequence.push([
            items,
            { opacity: 1, transform: 'translateY(0px)' },
            { delay: stagger(0.1), duration: 0.9, ease },
        ])
    } else if (animation === 'hero-home') {
        let h1 = element.querySelector('h1')
        let cols = element.querySelectorAll('.orbt-col')
        if (h1)
            sequence.push([
                h1,
                { opacity: 1, transform: 'translateY(0px)' },
                { duration: 0.9, ease },
            ])

        cols.forEach((col) => {
            sequence.push([
                col,
                { opacity: 1, transform: 'translateY(0px)' },
                { duration: 0.9, ease, at: '-0.7' },
            ])
        })
    }

    inView(
        element,
        () => {
            element.classList.add('anim-entering')
            if (sequence.length > 0) {
                animate(sequence, { delay: 0.1 }).then(() => {
                    element.classList.remove('anim-entering')
                    element.classList.add('anim-entered')
                })
            } else {
                element.addEventListener(
                    'transitionend',
                    () => {
                        element.classList.remove('anim-entering')
                        element.classList.add('anim-entered')
                    },
                    { once: true }
                )
            }
        },
        { margin: '0px 0px -100px 0px' }
    )
}
